export default __webpack_public_path__ + "static/media/spinner.98bb64fc.svg";